// Mock data for PT. Gurita Mandala Persada

export const companyInfo = {
  name: "PT. Gurita Mandala Persada",
  tagline: "Industrial Supply Company",
  yearsOfExperience: 25,
  industriesServed: 150,
  productCategories: 4,
  projectsCompleted: 500,
  phone: "+6222 6000204",
  phone1: "+6222 6078159",
  phone2: "+6222 6071862",
  email: "admingmp@guritamandala.com",
  address: "Jl. Peta (Lingkar Selatan), Komplek Ruko Kopo Plaza Blok F8, Kec. Bojongloa Kaler, Kota Bandung, Jawa Barat 40232, Indonesia",
  whatsapp1: "+62 8176599735 (Bp. Candra)",
  whatsapp2: "+62 817208808 (Bp. Rudi)"
};
export const aboutContent = {
  mission: "To deliver reliable, high-quality industrial supplies that empower manufacturing excellence and operational efficiency across Indonesia.",
  vision: "To be Southeast Asia's most trusted industrial supply partner, recognized for technical expertise, product quality, and long-term customer relationships.",
  story: "Established over two decades ago, PT. Gurita Mandala Persada has grown from a regional industrial supplier to a nationally recognized partner for manufacturing, construction, and industrial operations. Our commitment to quality, technical precision, and customer service has made us the preferred choice for organizations requiring dependable industrial materials and equipment. We understand that industrial operations demand reliability, and we deliver nothing less.",
  values: [
    { title: "Reliability", description: "Consistent quality and on-time delivery, every time" },
    { title: "Technical Expertise", description: "Deep knowledge of industrial applications and requirements" },
    { title: "Quality Assurance", description: "Only certified, tested, and proven industrial materials" },
    { title: "Customer Partnership", description: "Long-term relationships built on trust and performance" }
  ],
  milestones: [
    { year: "1992", event: "Company founded with focus on industrial valves and fittings", eventId: "Perusahaan didirikan dengan fokus pada valve dan fitting industri" },
    { year: "2005", event: "Expanded product line to include pipes and steel materials", eventId: "Memperluas lini produk termasuk pipa dan material baja" },
    { year: "2010", event: "ISO 9001 certification achieved for quality management", eventId: "Meraih sertifikasi ISO 9001 untuk manajemen mutu" },
    { year: "2015", event: "Established partnerships with leading global manufacturers", eventId: "Menjalin kemitraan dengan produsen global terkemuka" },
    { year: "2020", event: "Launched digital procurement platform for enhanced customer service", eventId: "Meluncurkan platform pengadaan digital untuk layanan pelanggan yang lebih baik" },
    { year: "2024", event: "Serving 150+ major industrial clients across Indonesia", eventId: "Melayani 150+ klien industri besar di seluruh Indonesia" }
  ]
};

export const productCategories = [
  {
    id: 1,
    name: "Valves",
    description: "Industrial-grade valves for precise flow control and system management",
    image: "https://images.unsplash.com/photo-1759148414485-5f624fe9d1ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwdmFsdmV8ZW58MHx8fHwxNzY1ODYwMTI4fDA&ixlib=rb-4.1.0&q=85",
    products: [
      { name: "Ball Valves", specs: "1/2\" - 12\", Various materials" },
      { name: "Gate Valves", specs: "Cast iron, Stainless steel" },
      { name: "Check Valves", specs: "Swing, Lift, Dual plate types" },
      { name: "Globe Valves", specs: "Pressure ratings up to PN40" },
      { name: "Butterfly Valves", specs: "Wafer, Lug, and Flanged" },
      { name: "Control Valves", specs: "Pneumatic and Electric actuators" }
    ]
  },
  {
    id: 2,
    name: "Pipes",
    description: "Durable piping solutions for fluid transport and structural applications",
    image: "https://images.unsplash.com/photo-1605600659873-d808a13e4d2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzdGVlbCUyMHBpcGV8ZW58MHx8fHwxNzY1ODYwMTMzfDA&ixlib=rb-4.1.0&q=85",
    products: [
      { name: "Seamless Steel Pipes", specs: "ASTM A106, Schedule 40-160" },
      { name: "Welded Steel Pipes", specs: "API 5L, ERW and LSAW" },
      { name: "Stainless Steel Pipes", specs: "304, 316, 321 grades" },
      { name: "Carbon Steel Pipes", specs: "Standard and custom dimensions" },
      { name: "Alloy Steel Pipes", specs: "High temperature applications" },
      { name: "PVC & HDPE Pipes", specs: "Industrial and utility grades" }
    ]
  },
  {
    id: 3,
    name: "Fittings",
    description: "Precision-engineered fittings for secure and efficient connections",
    image: "https://images.unsplash.com/photo-1761758674188-2b8e4c89c5e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwdmFsdmV8ZW58MHx8fHwxNzY1ODYwMTI4fDA&ixlib=rb-4.1.0&q=85",
    products: [
      { name: "Elbow Fittings", specs: "45° and 90°, Butt weld and threaded" },
      { name: "Tee Fittings", specs: "Equal and reducing types" },
      { name: "Reducer Fittings", specs: "Concentric and eccentric" },
      { name: "Flange Fittings", specs: "Slip-on, Weld neck, Blind, Threaded" },
      { name: "Coupling Fittings", specs: "Full and half coupling" },
      { name: "Cap & Plug Fittings", specs: "Various pressure ratings" }
    ]
  },
  {
    id: 4,
    name: "Steel Materials",
    description: "High-quality steel products for construction and industrial fabrication",
    image: "https://images.unsplash.com/photo-1600474848646-0142057eb600?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxzdGVlbCUyMHBpcGV8ZW58MHx8fHwxNzY1ODYwMTMzfDA&ixlib=rb-4.1.0&q=85",
    products: [
      { name: "Steel Plates", specs: "ASTM A36, Various thickness" },
      { name: "Steel Bars", specs: "Round, Square, Flat profiles" },
      { name: "Steel Beams", specs: "I-Beam, H-Beam, C-Channel" },
      { name: "Steel Angles", specs: "Equal and unequal leg angles" },
      { name: "Steel Sheets", specs: "Hot rolled and cold rolled" },
      { name: "Steel Wire & Mesh", specs: "Industrial grade specifications" }
    ]
  }
];

export const industries = [
  {
    id: 1,
    name: "Manufacturing",
    description: "Supplying precision components for automotive, electronics, and general manufacturing facilities"
  },
  {
    id: 2,
    name: "Oil & Gas",
    description: "High-pressure valves, pipes, and fittings for upstream, midstream, and downstream operations"
  },
  {
    id: 3,
    name: "Construction",
    description: "Structural steel, piping systems, and materials for commercial and industrial construction projects"
  },
  {
    id: 4,
    name: "Infrastructure",
    description: "Supporting utilities, water treatment, and public infrastructure development with reliable materials"
  },
  {
    id: 5,
    name: "Power & Utilities",
    description: "Critical components for power generation, transmission, and distribution systems"
  }
];

export const testimonials = [
  {
    id: 1,
    company: "PT. Manufacturing Excellence",
    person: "Budi Santoso",
    position: "Procurement Manager",
    content: "Gurita Mandala Persada has been our trusted supplier for over 8 years. Their technical expertise and product quality are unmatched."
  },
  {
    id: 2,
    company: "Indonesia Infrastructure Corp",
    person: "Siti Rahayu",
    position: "Project Director",
    content: "Reliable delivery, consistent quality, and excellent technical support. They understand the demands of large-scale projects."
  },
  {
    id: 3,
    company: "Energy Solutions Ltd",
    person: "Ahmad Wijaya",
    position: "Engineering Lead",
    content: "Their product range and technical knowledge have made them our go-to partner for all industrial supply requirements."
  }
];

// Mock form submission
export const submitQuotationRequest = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Quotation request submitted (mock):', formData);
      resolve({ success: true, message: 'Your quotation request has been received. We will contact you within 24 hours.' });
    }, 1000);
  });
};